import { useState } from "react";
import { colors } from "../../Config/Colors";
import { FormControl, Select, MenuItem, Box } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export const DayFilterButton = ({ handleClick, active, button, isLoading = false }) => {
  const options = [
    { id: "today", label: "Bugün" },
    { id: "yesterday", label: "Dün" },
    { id: "thisweek", label: "Bu Hafta" },
    { id: "thismonth", label: "Bu Ay" },
    { id: "thisyear", label: "Bu Yıl" },
  ];

  const baseButtonClass =
    button ||
    "px-3 py-1.5 rounded-full text-sm font-medium transition-colors";

  // Yükleme sırasında butonlar skeleton — tıklanamaz
  if (isLoading) {
    return (
      <div className="flex items-center gap-2 bg-white/60 border border-gray-200 rounded-xl p-1 shadow-sm">
        {options.map((option) => (
          <span
            key={option.id}
            className="h-9 w-12 sm:w-16 bg-gray-200 rounded-xl animate-pulse"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 bg-white/60 border border-gray-200 rounded-xl p-1 shadow-sm">
      {options.map((option) => {
        const isActive = active === option.id;
        return (
          <button
            key={option.id}
            type="button"
            onClick={() => handleClick(option.id)}
            className={`${baseButtonClass} ${
              isActive
                ? "bg-main text-white shadow cursor-default"
                : "text-black hover:bg-white/70"
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export const MonthFilterButton = ({
  months,
  selectedMonth,
  setSelectedMonth,
}) => {
  const [open, setOpen] = useState(false);

  const handleChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: colors.primary.hex || "#1976d2",
      },
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.primary.hex || "#1976d2",
            },
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            "&.Mui-selected": {
              backgroundColor: `${colors.primary.hex}20` || "#1976d220",
              "&:hover": {
                backgroundColor: `${colors.primary.hex}30` || "#1976d230",
              },
            },
            "&:hover": {
              backgroundColor: `${colors.primary.hex}10` || "#1976d210",
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ minWidth: 160 }}>
        <FormControl fullWidth size="small">
          <Select
            id="month-filter-select"
            value={selectedMonth}
            onChange={handleChange}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            displayEmpty
            MenuProps={{
              sx: { zIndex: 10000 },
              PaperProps: { sx: { zIndex: 10000 } },
            }}
            renderValue={(selected) => {
              const selectedMonthData = months[selected];
              return selectedMonthData
                ? `${selectedMonthData.monthName} ${selectedMonthData.year}`
                : "Ay Seçiniz";
            }}
            sx={{
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0, 0, 0, 0.12)",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: colors.primary.hex || "#1976d2",
              },
            }}
          >
            {months.map((month, index) => (
              <MenuItem key={index} value={index}>
                {month.monthName} {month.year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </ThemeProvider>
  );
};
